import React from 'react';
import { UploadIcon } from '../../../assets/UploadIcon';
import DemoImage from '../../../assets/customization/demo.png';

interface ImageUploadBoxProps {
    id: 'desktopSrc' | 'mobileSrc';
    label: string;
    hint: string;
    src: string;
    uploading: boolean;
    disabled: boolean;
    boxClass: string;
    onUpload: React.ChangeEventHandler<HTMLInputElement>;
    onRemove: () => void;
}

const ImageUploadBox: React.FC<ImageUploadBoxProps> = ({ 
    id, 
    label, 
    hint, 
    src, 
    uploading, 
    disabled, 
    boxClass, 
    onUpload, 
    onRemove 
}) => {
    const isDisabled = disabled || uploading;

    return (
        <div className="field-group">
            <p className="field-label"><b>{label}</b></p>
            {hint && <p className="field-hint">{hint}</p>}
            <div className={`upload-box ${boxClass}`}>
                {src && (
                    <button 
                        type="button" 
                        className="remove-image-btn" 
                        onClick={(e) => {
                            e.preventDefault();
                            onRemove();
                        }} 
                        disabled={isDisabled}
                        title={`Remove ${label}`}
                    >
                        <div className="icoTrash"></div>
                    </button>
                )}
                
                <input 
                    type="file" 
                    id={id} 
                    onChange={onUpload} 
                    disabled={isDisabled} 
                    accept=".png, .jpg, .jpeg" 
                />
                
                <div 
                    className={`image-preview ${!src ? 'is-demo' : ''}`} 
                    style={{ 
                        backgroundImage: src ? `url(${src})` : `url(${DemoImage})`, 
                        opacity: uploading ? 0.5 : 1 
                    }} 
                />
                
                <label htmlFor={id} className={`upload-bottom-bar ${isDisabled ? 'disabled-label' : ''}`}>
                    <span className="upload-text">{uploading ? 'Uploading...' : 'Upload Photo'}</span>
                    <div className="upload-btn"><UploadIcon /></div>
                </label>
            </div>
        </div>
    );
};

export default ImageUploadBox;